/* eslint-disable import/prefer-default-export */

interface Dictionary<T> {
    [key: string]: T;
}

export function getHTMLParagraphs(htmlInput: string): string {
    if (!htmlInput) return htmlInput;

    return htmlInput.split(/(?:\r\n){2,}/).map(p => `<p>${p}</p>`).join('');
}

export function getSlugFromTitle(title: string): string {
    const umlautMap: Dictionary<string> = {
        ä: 'ae',
        ö: 'oe',
        ü: 'ue',
        ß: 'ss',
    };

    return title.toLowerCase()
        .replace(/[^a-z0-9]+/g, (s: string): string => umlautMap[s] || '-')
        .replace(/[^a-z0-9]+/g, '-');
}
